import React from 'react';
import './CTA.scss';
import Arrow from '../Arrow/Arrow';

function Button({ origin }) {
  return (
    <>
      {origin === 'intro' ? (
        <a
          className="cta__contents__link"
          href="https://www.morganstanley.com/Themes/global-space-economy/?cid=mg-cap-cnncreat-12577"
          target="_blank"
          rel="sponsored noopener"
        >
          <button className="cta__contents__button cta__contents__button-intro">
            EXPLORE THE NEW SPACE ECONOMY
            <Arrow location="cta" />
          </button>
        </a>
      ) : (
        <a
          className="cta__contents__link"
          href="https://sponsorcontent.cnn.com/interactive/morganstanley/creating-space/"
          target="_blank"
           rel="sponsored"
        >
          <button className="cta__contents__button cta__contents__button-end">
            JOIN US
            <Arrow location="cta" />
          </button>
        </a>
      )}
    </>
  );
}

export default Button;
